// extracted by mini-css-extract-plugin
export default {"container":"PerformanceSection_container__P-IBg","header":"PerformanceSection_header__BJN2G","wrapperCard":"PerformanceSection_wrapperCard__RlEDG"};